import createReactClass from 'create-react-class';
'use strict';

// Import Libraries
import React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';

// -----------------------------------------------------------
//  BSOverlay
// -----------------------------------------------------------
// Simple pure-React component so we don't have to remember
// BS's classes
const BSOverlay = createReactClass({
  // The following two methods are the only places we need to
  // integrate BS or jQuery with the components lifecycle methods.
  componentDidMount() {
    // When the component is added, turn it into a modal
    $(ReactDOM.findDOMNode(this)).
      modal({show: !!this.props.show}).
      on('shown.bs.modal', this.handleShown).
      on('hide.bs.modal', this.handleHide);
  },
  componentWillUnmount() {
    $(ReactDOM.findDOMNode(this)).
      off('shown.bs.modal', this.handleShown).
      off('hide.bs.modal', this.handleHide);
  },
  componentDidUpdate(prevProps) {
    if (prevProps.show != this.props.show)
      this.props.show ? this.open() : this.close();
  },

  render() {
    return (
      <div className={ classNames('modal', 'fade', this.props.extraClassNames) }>
        <div className="modal-dialog modal-xl">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            </div>
            <div className="modal-body">
              { this.props.children }
            </div>
          </div>
        </div>
      </div>
    );
  },

  open() {
    $(ReactDOM.findDOMNode(this)).modal('show');
  },
  close() {
    $(ReactDOM.findDOMNode(this)).modal('hide');
  },
  toggle() {
    if (this.props.show) {
      this.open();
    } else {
      this.close();
    }
  },

  handleShown() {
    if (this.props.onShown) {
      this.props.onShown();
    }
  },
  handleHide() {
    if (this.props.onHide) {
      this.props.onHide();
    }
  }
});

export default BSOverlay;
